import { WebsitePreviewProps } from './Types'
import { DefaultPreview } from 'screens/BrandKits/components/BrandKitWidget/DefaultPreview'
import Styles from './WebsitePreview.module.scss'

export const WebsitePreview = ({ brandKit, website }: WebsitePreviewProps) => {
  const { screenshot_url } = website
  const { name } = brandKit

  if (!screenshot_url) {
    return <DefaultPreview brandKit={brandKit} />
  }

  return (
    <div className={Styles.preview}>
      <img src={screenshot_url} alt={name} className={Styles.previewImage} />
    </div>
  )
}
